export default {"src":"/_next/static/media/etape-bp-admin.3c7eeb14.gif","height":912,"width":1276};